import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import ImageContainer from '@/components/ImageContainer/ImageContainer';
import { getAddressFromCoordinates } from '@/utils/geocoder';

interface Props {
  closeModal: () => void;
  location: {
    officeLogo?: {
      svg: {
        title: string;
        url: string;
      };
    };
    officeMap: {
      lat: number;
      lon: number;
    };
    officeName: string;
    officePhone?: string;
  };
}

interface ILocation {
  street: string;
  city: string;
  state: string;
  zip: string;
  country: string;
}

const CrossmodModal = ({ location, closeModal }: Props) => {
  const [address, setAddress] = useState<ILocation | undefined>();
  const locationPhone =
    location?.officePhone?.length === 10
      ? `${location.officePhone.substring(0, 3)}-${location.officePhone.substring(3, 6)}-${location.officePhone.substring(6, 10)}`
      : null;

  useEffect(() => {
    getAddressFromCoordinates(
      location?.officeMap?.lat,
      location?.officeMap?.lon
    ).then((res) => {
      res ? setAddress(res) : setAddress(undefined);
    });
  }, [location]);

  return (
    <div className="mx-auto rounded-[10px] bg-[#e1ecf8] lg:absolute lg:left-[5%] lg:top-[10%]">
      <div className="p-2.5 text-right">
        <button
          className="h-5 w-5 rounded-full border-none bg-clayton-blue text-[12px] font-extrabold text-white"
          onClick={closeModal}
        >
          X
        </button>
      </div>
      <div className="mx-auto w-[95%] pb-5 sm:flex sm:w-mobile sm:gap-8 lg:block lg:w-full lg:p-4">
        <div className="mx-auto mb-2.5 w-[300px]">
          {location?.officeLogo && (
            <ImageContainer
              src={location.officeLogo?.svg?.url}
              alt={location.officeLogo?.svg?.title}
            />
          )}
        </div>
        <div className="rounded-xl bg-clayton-blue px-2.5 py-4 font-acumin text-[1rem] font-bold text-white sm:m-auto sm:w-1/2 lg:w-full">
          {address !== null && (
            <>
              <div>{location.officeName}</div>
              <div>{address?.street}</div>
              <div>{`${address?.city}, ${address?.state} ${address?.zip}, ${address?.country}`}</div>
              {location?.officePhone && (
                <div>
                  <Link
                    href={`tel:${locationPhone}`}
                    target="_blank"
                    aria-label={`Telephone us at ${locationPhone}`}
                    className="flex cursor-pointer text-white no-underline"
                  >
                    <Image
                      src="/public-assets/icon-phone.svg"
                      alt="Phone Icon"
                      width={14}
                      height={13}
                      className="mr-[5px]"
                    />
                    {locationPhone}
                  </Link>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CrossmodModal;
